import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { IOrderDetails } from "../../../../../../models/IOrder";
import formatCurrency from "../../../../../../utils/formatCurrency";

import { Controller, useForm } from "react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { ModalStyled, PaymentAlert } from "./styled";
import { classNames } from "primereact/utils";
import { MdOutlineInfo } from "react-icons/md";

interface IModalCheckPaymentInfo {
	order: IOrderDetails;
	show: boolean;
	isLoading: boolean;
	onSubmit: (data: any) => void;
	onHide: () => void;
}

const validationSchema = Yup.object({
	payment_type: Yup.number().required("Este campo é obrigatório"),
	installments: Yup.number().required("Este campo é obrigatório"),
	discount: Yup.number(),
}).required();

export const ModalCheckPaymentInfo: React.FC<IModalCheckPaymentInfo> = (
	props
) => {
	const { order, show, isLoading, onSubmit, onHide } = props;
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({ resolver: yupResolver(validationSchema) });

	const { t: translation } = useTranslation();

	// Payment Type
	const paymentOptions = [
		{
			label: "Cartão de Crédito",
			value: 1,
		},
		{
			label: "Boleto",
			value: 2,
		},
	];

	// Installments
	const [installmentsOptions, setInstallmentsOptions] = useState<any[]>([]);
	const handleInstallmentsOptions = () => {
		if (order) {
			let installOpt: any[] = [];
			[...Array(12)].map((e, i) =>
				installOpt.push({
					label: `${i + 1}x de ${formatCurrency(
						order.amount / (i + 1)
					)}`,
					value: i + 1,
				})
			);

			if (installOpt.length > 0) {
				setInstallmentsOptions(installOpt);
			}
		}
	};

	useEffect(() => {
		handleInstallmentsOptions();
	}, []);

	const getFormErrorMessage = (name: any) => {
		return errors && name && errors[name] ? (
			<small className="p-error">{errors[name]?.message}</small>
		) : (
			<></>
		);
	};

	return (
		<ModalStyled
			loading={isLoading}
			show={show}
			submitButtonText={translation("manager.user.confirm")}
			variant="form-modal-default"
			hasDefaultIcon={false}
			onHide={onHide}
		>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Modal.Header
					className=""
					closeButton
				>
					<Modal.Title>Dados de faturamento</Modal.Title>
				</Modal.Header>
				<Modal.Body className="px-3">
					<Row className="mb-3">
						<Col>
							<PaymentAlert>
								<div className="d-flex">
									<div className="mx-3">
										<MdOutlineInfo size={20} />
									</div>
									<div>
										<p className="m-0">
											Para avançar com a alteração do
											status do pedido, é fundamental
											fornecer as informações abaixo:
										</p>
									</div>
								</div>
							</PaymentAlert>
						</Col>
					</Row>

					<Row>
						<Col
							xs={12}
							className="mb-3"
						>
							<Form.Group>
								<Form.Label>Forma de pagamento</Form.Label>
								<Controller
									name="payment_type"
									control={control}
									rules={{
										required: "Este campo é obrigatório.",
									}}
									render={({ field, fieldState }) => (
										<Dropdown
											id={field.name}
											value={field.value}
											options={paymentOptions}
											focusInputRef={field.ref}
											onChange={(e) =>
												field.onChange(e.value)
											}
											className={classNames({
												"w-100 select-form-default":
													true,
												"p-invalid": fieldState.error,
											})}
										/>
									)}
								/>
								{getFormErrorMessage("payment_type")}
							</Form.Group>
						</Col>
						<Col
							xs={12}
							className="mb-3"
						>
							<Form.Group>
								<Form.Label>Parcelamento</Form.Label>
								<Controller
									name="installments"
									control={control}
									rules={{
										required: "Este campo é obrigatório.",
									}}
									render={({ field, fieldState }) => (
										<Dropdown
											id={field.name}
											value={field.value}
											options={installmentsOptions}
											focusInputRef={field.ref}
											onChange={(e) =>
												field.onChange(e.value)
											}
											className={classNames({
												"w-100 select-form-default":
													true,
												"p-invalid": fieldState.error,
											})}
										/>
									)}
								/>
								{getFormErrorMessage("installments")}
							</Form.Group>
						</Col>
						<Col
							xs={12}
							className="mb-3"
						>
							<Form.Group>
								<Form.Label>Desconto (Opcional)</Form.Label>
								{/* <Form.Control disabled={true}> */}
								<Controller
									name="discount"
									control={control}
									rules={{}}
									render={({ field, fieldState }) => (
										<>
											<InputNumber
												id={field.name}
												inputRef={field.ref}
												value={field.value}
												onBlur={field.onBlur}
												onValueChange={(e) =>
													field.onChange(e)
												}
												useGrouping={false}
												placeholder="R$ 0,00"
												mode="currency"
												currency="BRL"
												locale="pt-BR"
												className="input-material-price w-100"
											/>
											{getFormErrorMessage(field.name)}
										</>
									)}
								/>
							</Form.Group>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="outline-primary"
						className="mb-1"
						disabled={isLoading}
						onClick={onHide}
					>
						{translation("cancel")}
					</Button>

					<div>
						<Button
							type="submit"
							variant={"primary"}
							className="mb-1"
							disabled={isLoading}
						>
							{translation("manager.user.confirm")}
						</Button>
						{isLoading && (
							<Spinner
								animation="border"
								variant={"primary"}
								style={{
									width: "1.2rem",
									height: "1.2rem",
									borderWidth: "0.15em",
									borderRightColor: "transparent",
									marginLeft: "5px",
								}}
							/>
						)}
					</div>
				</Modal.Footer>
			</Form>
		</ModalStyled>
	);
};
